import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { formatDate, DATE_FORMATS, dateToRelativeTrans, parseIsoDateOrTimestamp, } from './functions';
import s from './Timestamp.scss';
var Timestamp = function (_a) {
    var className = _a.className, timestamp = _a.timestamp, showTooltip = _a.showTooltip, isShort = _a.isShort, isCapitalized = _a.isCapitalized, showFullLengthOnMobile = _a.showFullLengthOnMobile;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var isMobile = useContext(MobileContext);
    var isMounted = useIsMounted();
    if (!timestamp) {
        return null;
    }
    var relativeTrans = dateToRelativeTrans(timestamp, (isMobile && !showFullLengthOnMobile) || isShort);
    var formattedDate = formatDate(timestamp, DATE_FORMATS.DateTime.FullTimeZone, i18n.language);
    return (React.createElement("time", { "aria-label": formattedDate, dateTime: parseIsoDateOrTimestamp(timestamp).toISOString(), className: classnames(isCapitalized && s['capitalize'], className), title: showTooltip && isMounted ? formattedDate : undefined, suppressHydrationWarning: true }, t(relativeTrans.key, { count: relativeTrans.value })));
};
Timestamp.displayName = 'Timestamp';
export default React.memo(Timestamp);
//# sourceMappingURL=Timestamp.js.map